import { SelectProps } from '@radix-ui/react-select';
import { capitalizeFirstLetter, cn } from '@shared/lib/utils';
import { ReactNode } from 'react';
import { FormLabel } from './ui/form';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

export type SimpleSelectOption =
  | string
  | {
      value: string;
      disabled?: boolean;
      /** Leading adornment, e.g. a lock icon on a gated option. */
      icon?: ReactNode;
    };

interface SimpleSelectProps extends SelectProps {
  defaultValue?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  options: SimpleSelectOption[];
  className?: string;
  label?: string;
  triggerClassName?: string;
}
export default function SimpleSelect({
  options,
  placeholder,
  className,
  label,
  triggerClassName,
  ...props
}: SimpleSelectProps) {
  return (
    <div className={cn('', className)}>
      {label && <FormLabel>{label}</FormLabel>}
      <Select {...props}>
        <SelectTrigger className={cn('w-full', triggerClassName)}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {options
              .map((option) =>
                typeof option === 'string' ? { value: option } : option
              )
              .map(({ value, disabled, icon }) => (
                <SelectItem
                  value={value}
                  key={value}
                  hideIndicator
                  disabled={disabled}
                >
                  {icon ? (
                    <span className="flex items-center gap-2">
                      {icon}
                      {capitalizeFirstLetter(value)}
                    </span>
                  ) : (
                    capitalizeFirstLetter(value)
                  )}
                </SelectItem>
              ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
